<script>
import { get } from 'lodash'
import TopMenuPatient from './topMenuPatient'
import TopMenuProfessional from './topMenuProfessional'
import { routeStartsWith } from '@/helpers/routes'

export default {
  name: 'layout-header',

  computed: {
    routeIsPatientLoadingPage () {
      // if (get(this.$route, 'path', null) === '/') {
      this.pathIndex = true
      return routeStartsWith(this.$route, 'patient.loading-page.')
      // return this.$router.push({name: 'patient.loading-page.index'})
      // }
      // this.pathIndex = true
      // return routeStartsWith(this.$route, 'patient.loading-page.')
    },
    routeIsProfessionalLoadingPage () {
      this.pathIndex = false
      return routeStartsWith(this.$route, 'professional.loading-page.')
    },
    isIndex () {
      if (get(this.$route, 'path', null) === '/') {
      }
    }
  },
  methods: {
  },
  data: () => {
    return {
      pathIndex: false
    }
  },
  components: {
    TopMenuPatient,
    TopMenuProfessional
  }
}
</script>

<template lang="pug">
  #header
    TopMenuPatient(v-if='!routeIsProfessionalLoadingPage')
    TopMenuProfessional(v-if='routeIsProfessionalLoadingPage && !routeIsPatientLoadingPage')
</template>



// WEBPACK FOOTER //
// src/layout/headers/index.vue